import isCustomer from '@/middlewares/isCustomer';
export default [
    /**
     *  FOR CUSTOMER ONLY
     */
    {
        path: '/customer-dashboard',
        component: () => import('@/views/customer/Dashboard.vue'),
        name: 'CustomerDashboard',
        addtoNav: false,
        meta: {
            navText: 'Dashboard',
            middleware: [isCustomer]
        }
    },

    {
        path: '/customer-registered-products',
        component: () => import('@/views/customer/RegisteredProducts.vue'),
        name: 'CustomerRegisteredProducts',
        addtoNav: false,
        meta: {
            navText: 'Registered products',
            middleware: [isCustomer]
        }
    },

    {
        path: '/customer-registered-products-warranties',
        component: () => import('@/views/customer/RegisteredProductsWarranty.vue'),
        name: 'CustomerRegisteredProductsWarranties',
        addtoNav: false,
        meta: {
            navText: 'Registered products warranty',
            middleware: [isCustomer]
        }
    },
    {
        path: '/customer-registered-products-repairs',
        component: () => import('@/views/customer/RegisteredProductsRepairs.vue'),
        name: 'CustomerRegisteredProductsRepairs',
        addtoNav: false,
        meta: {
            navText: 'Registered products repairs',
            middleware: [isCustomer]
        }
    },

    {
        path: '/customer-registered-products/add',
        component: () => import('@/views/customer/RegisteredProductAdd.vue'),
        name: 'CustomerRegisteredProductsAdd',
        addtoNav: false,
        meta: {
            navText: 'Add New Product',
            middleware: [isCustomer]
        }
    },

    {
        path: '/customer-registered-products/:id',
        component: () => import('@/views/customer/RegisteredProductEdit.vue'),
        name: 'CustomerRegisteredProductEdit',
        addtoNav: false,
        meta: {
            navText: 'Edit Registered products',
            middleware: [isCustomer]
        }
    }
];
